export type Category = any

export interface CategoriesState {
    loading: boolean
    resultcategory: string | null
    categories: Category[]
    category: Category | null
    categoriesForSelect: Category[]
    total: number
}

const initialState: CategoriesState = {
    loading: false,
    resultcategory: null,
    categories: [],
    category: null,
    categoriesForSelect: [],
    total: 0,
}

export const categoriesReducer = (state: CategoriesState = initialState, action: { type: string; payload?: any }): CategoriesState => {
    switch (action.type) {
        case "CATEGORY_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                categories: action.payload.categories as Category[],
                total: action.payload.total,
                resultcategory: null
            }

        case "CATEGORY_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                categoriesForSelect: action.payload as Category[],
                loading: false,
                resultcategory: null
            }

        case "CATEGORY_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                category: action.payload.category as Category,
            }

        case "CATEGORY_RESET":
            return {
                ...state,
                category: null,
            }

        case "CATEGORY_ADD_SUCCESS":
            return {
                ...state,
                loading: false,
                resultcategory: action.payload.message,
                category: action.payload.category as Category,
                categories: [...state.categories, action.payload.category as Category],
            }

        case "CATEGORY_WRONG_SUCCESS":
            return {
                ...state,
                loading: false,
                resultcategory: action.payload.message,
            }

        case "CATEGORY_EDIT_SUCCESS":
            if (action.payload.category && action.payload.category._id) {
                return {
                    ...state,
                    loading: false,
                    resultcategory: action.payload.message,
                    category: action.payload.category as Category,
                    categories: state.categories.map((u: any) =>
                        u._id === action.payload.category._id ? (action.payload.category as Category) : u
                    )
                }
            } else {
                return {
                    ...state,
                    loading: false,
                    resultcategory: action.payload as string,
                }
            }
        case "CATEGORY_DELETE_SUCCESS":
            return {
                ...state,
                loading: false,
                categories: state.categories.filter((u: any) => u._id !== action.payload.idCategory),
                resultcategory: action.payload.message
            }

        case 'CATEGORY_DELETE_INUSE':
            return {
                ...state,
                loading: false,
                resultcategory: action.payload.message
            }

        case "CATEGORY_NOTHINGHERE":
            return {
                ...state,
                loading: false,
                resultcategory: "nothinghere",
            }

        case "CATEGORY_RESET_RESULT":
            return {
                ...state,
                resultcategory: null,
            }

        case "CATEGORY_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "CATEGORY_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}
